import React from 'react';
import ResumeDownload from './ResumeDownload';

export interface ExperienceProps {}

const Experience: React.FC<ExperienceProps> = (props) => {
    return (
        <div className="site-page-content">
      
            <div style={styles.headerContainer}>
                <div style={styles.header}>
                    <div style={styles.headerRow}>
                        <h1>PLDT Global</h1>
                        <a
                            rel="noreferrer"
                            target="_blank"
                            href={'https://www.pldtglobal.com/'}
                        >
                            <h4>PLDT Global</h4>
                        </a>
                    </div>
                    <div style={styles.headerRow}>
                        <h3>Global Network Planning and Engineering</h3>
                        <b>
                            <p>June 2025 - July 2025</p>
                        </b>
                    </div>
                </div>
            </div>
            <div className="text-block">
                <p>
                    Played a key role in supporting global network planning and operations by validating critical infrastructure data, 
                    improving provisioning workflows, and contributing to ISO-compliant documentation processes within a high-demand telecom 
                    environment.
                </p>
                <br />
                <ul>
                    <li>
                        <p>
                            Verified and updated circuit and port inventory across international Points of Presence (PoPs), supporting accurate 
                            provisioning and reducing configuration inconsistencies across global infrastructure.
                        </p>
                    </li>
                    <li>
                        <p>
                           Created and maintained technical documentation for Global Service Orders (GSO), Service Request Forms (SRF), and infrastructure changes, 
                           directly supporting PLDT Global’s ISO 9001 quality management standards.
                            
                        </p>
                    </li>
                    <li>
                        <p>
                            Worked alongside NOC engineers to trace circuit paths and document network flow diagrams, contributing to enhanced infrastructure visibility 
                            and proactive monitoring initiatives.
                        </p>
                    </li>
                    <li>
                        <p>
                           Built foundational expertise in enterprise-level asset validation, cross-team technical coordination, and structured documentation under operational 
                           and compliance requirements.
                        </p>
                    </li>
                </ul>
            </div>
                        <div style={styles.headerContainer}>
                <div style={styles.header}>
                    <div style={styles.headerRow}>
                        <h1>FiveM</h1>
                        <a
                            rel="noreferrer"
                            target="_blank"
                            href={'https://fivem.net/'}
                        >
                            <h4>FiveM</h4>
                        </a>
                    </div>
                    <div style={styles.headerRow}>
                        <h3>Anti-Cheat Moderator</h3>
                        <b>
                            <p>Aug 2024 - Feb 2025</p>
                        </b>
                    </div>
                </div>
            </div>
            <div className="text-block">
                <p>
                    Targeted towards maintaining fair play and community trust in a high-traffic multiplayer gaming
                    environment, this role involved close monitoring of real-time player behavior and proactive incident
                    response to uphold server integrity.
                </p>
                <br />
                <ul>
                    <li>
                        <p>
                            Conducted remote forensic investigations on suspected cheaters across multiple FiveM servers using tools like OSForensics, Process Hacker, and VirusTotal, 
                            contributing to the security of a 300+ player environment.
                        </p>
                    </li>
                    <li>
                        <p>
                            Performed manual PC checks over AnyDesk, analyzing registry entries, deleted files, browser histories, and system artifacts 
                            to detect obfuscated loaders and cheat tool remnants.
                            
                        </p>
                    </li>
                    <li>
                        <p>
                            Applied a zero-trust investigation workflow, combining antivirus scans with signature matching and manual triage to eliminate 
                            false positives and validate evidence before enforcing bans.
                        </p>
                    </li>
                    <li>
                        <p>
                           Gained practical, hands-on experience in incident response workflows, real-time security operations, and behavioral threat intelligence,
                            often under pressure in fast-paced environments.
                        </p>
                    </li>
                </ul>
            </div>
            <div style={styles.headerContainer}>
                <div style={styles.header}>
                    <div style={styles.headerRow}>
                        <h1>IECEP–MUSC</h1>
                        <a
                            target="_blank"
                            rel="noreferrer"
                            href={'https://www.facebook.com/iecep.musc'}
                        >
                            <h4>IECEP-MUSC</h4>
                        </a>
                    </div>
                    <div style={styles.headerRow}>
                        <h3>Board Auditor</h3>
                        <b>
                            <p>Aug 2024 - May 2025</p>
                        </b>
                    </div>
                </div>
            </div>
            <div className="text-block">
                <p>
                    Responsible for independently reviewing and validating the organization’s financial
                    records and procedures. This role emphasized compliance, accountability, and clear communication with
                    executive officers to ensure transparency and integrity in all financial matters.
                </p>
                <br />
                <ul>
                    <li>
                        <p>
                            Reviewed and audited financial records to ensure transparency, accuracy, and compliance with university and organizational financial policies.
                        </p>
                    </li>
                    <li>
                        <p>
                            Worked closely with the executive board to advise on fundraising strategies and ensure responsible fund allocation for organizational initiatives.
                        </p>
                    </li>
                    <li>
                        <p>
                            Contributed to the oversight of budget reports and financial summaries used for strategic planning and documentation.
                        </p>
                    </li>
                </ul>
            </div>
            <div style={styles.headerContainer}>
                <div style={styles.header}>
                    <div style={styles.headerRow}>
                        <h1>IECEP-MUSC</h1>
                        <a
                            target="_blank"
                            rel="noreferrer"
                            href={'https://www.facebook.com/iecep.musc'}
                        >
                            <h4>IECEP-MUSC</h4>
                        </a>
                    </div>
                    <div style={styles.headerRow}>
                        <h3>Treasurer</h3>
                        <b>
                            <p>Mar 2024 - Aug 2024</p>
                        </b>
                    </div>
                </div>
            </div>
            <div className="text-block">
                <p>
                    Oversaw the financial health of the organization, 
                    managing budgets, coordinating sponsorships, and ensuring all financial operations aligned with institutional policies. 
                    This role demanded accuracy, transparency, and collaboration to fund key student led events and initiatives.
                </p>
                <br />
                <ul>
                    <li>
                        <p>
                            Managed all financial operations, including budgeting, expense tracking, and financial reporting for a student body of over 100 members.
                        </p>
                    </li>
                    <li>
                        <p>
                            Handled coordination with corporate and academic sponsors to secure funding for events such as technical workshops, seminars, and intercollegiate competitions.
                        </p>
                    </li>
                    <li>
                        <p>
                            Ensured timely submission of financial documents and compliance with university guidelines, maintaining strong financial standing throughout the term.
                        </p>
                    </li>
                </ul>
            </div>
            <ResumeDownload />
        </div>
    
    );
};

const styles: StyleSheetCSS = {
    header: {
        flexDirection: 'column',
        justifyContent: 'space-between',
        width: '100%',
    },
    skillRow: {
        flex: 1,
        justifyContent: 'space-between',
    },
    skillName: {
        minWidth: 56,
    },
    skill: {
        flex: 1,
        padding: 8,
        alignItems: 'center',
    },
    progressBar: {
        flex: 1,
        background: 'red',
        marginLeft: 8,
        height: 8,
    },
    hoverLogo: {
        height: 32,
        marginBottom: 16,
    },
    headerContainer: {
        alignItems: 'flex-end',
        width: '100%',
        justifyContent: 'center',
    },
    hoverText: {
        marginBottom: 8,
    },
    indent: {
        marginLeft: 24,
    },
    headerRow: {
        justifyContent: 'space-between',
        alignItems: 'flex-end',
    },
    row: {
        display: 'flex',
        justifyContent: 'space-between',
    },
};

export default Experience;
